// src/lib/prefetch.ts
import { collection, doc, getDoc, getDocs, query, where } from 'firebase/firestore';
import type { Firestore } from 'firebase/firestore';

/**
 * Prefetch the user's cruise data and profile to warm the local IndexedDB cache.
 * Safe to call after login; it will no-op if already cached.
 * User doc cache ensures fast app load on poor internet (e.g. cruise ship).
 */
export async function prefetchUserData(db: Firestore, userId: string) {
  try {
    // Prime user doc first - AuthContext uses it on cold start
    await getDoc(doc(db, 'users', userId));
    const cruisesRef = collection(db, 'cruises');
    const q = query(cruisesRef, where('userId', '==', userId));
    await getDocs(q); // triggers cache hydration
    // Also prime cruiseMetadata so images and lookups are instant
    await getDocs(collection(db, 'cruiseMetadata'));
  } catch (e) {
    // Non-fatal: the app will still lazily fetch on demand
    console.warn('Prefetch warning:', e);
  }
}
